module.exports = __webpack_public_path__ + "static/media/contained-round.cefb9bd4.svg";